export enum ForgottenPasswordResponseStatus {
    ERROR = 0,
    SUCCESS = 1,
    NO_ACCOUNT = 2
}
